export type GroupOwnerType = "app" | "org";
export const GROUP_OWNER_TYPE = {
  APP: "app",
  ORG: "org"
};
